export const geoPluginMock = {
  data: {
    geoplugin_request: "81.23.93.102",
    geoplugin_status: 200,
    geoplugin_delay: "2ms",
    geoplugin_credit: "Some of the returned data includes GeoLite data created by MaxMind, available from <a href='http://www.maxmind.com'>http://www.maxmind.com</a>.", //prettier-ignore
    geoplugin_city: "Genoa",
    geoplugin_region: "Liguria",
    geoplugin_regionCode: "GE",
    geoplugin_regionName: "Provincia di Genova",
    geoplugin_areaCode: "",
    geoplugin_dmaCode: "",
    geoplugin_countryCode: "IT",
    geoplugin_countryName: "Italy",
    geoplugin_inEU: 1,
    geoplugin_euVATrate: 22,
    geoplugin_continentCode: "EU",
    geoplugin_continentName: "Europe",
    geoplugin_latitude: "44.4048",
    geoplugin_longitude: "8.9444",
    geoplugin_locationAccuracyRadius: "50",
    geoplugin_timezone: "Europe/Rome",
    geoplugin_currencyCode: "EUR",
    geoplugin_currencySymbol: "€",
    geoplugin_currencySymbol_UTF8: "€",
    geoplugin_currencyConverter: 0.8244,
  },
  status: 200,
};
